import { datadogLogs } from '@datadog/browser-logs';
import { format, parseISO } from 'date-fns';

import {
    getAvoidMotorway,
    getAvoidToll,
    getCalculateAlternatives,
    getConsiderTraffic,
    getCurrency,
    getDepartureDate,
    getDepartureTime,
    getVehicleAttributes,
    getVehicleCostsPerKilometer,
} from '../../application/redux/options/optionsSelectors';
import { routesActions } from '../../application/redux/routes/routesReducer';
import { config } from '../../config';
import { getUserAccount } from '../../configuration';
import { fetchData } from '../../configuration/setup/fetch';
import { clearRoute } from '../livemonitorCommunication/propagateRoutesToParent';
import { createRouteQuery, type RouteParameters } from './createRouteQuery';
import { enrichWaypointsWithCoordinates } from './fetchWaypointCoordinates';
import { mapRoutes } from './mappers/mapRoutes';

const HERE_ROUTE_ENDPOINT_BASEURL = 'https://router.hereapi.com';

export interface AdditionalParams {
    departureDateTime: Date;
    vehicleCostsPerKilometer: number;
    currency: string;
    timezone: string;
}

export const fetchRoutes = async (dispatch: Function, getState: Function) => {
    try {
        dispatch(routesActions.fetchRoutesTriggered());
        clearRoute();

        const orderedWaypointsWithCoordinates = await enrichWaypointsWithCoordinates(dispatch, getState);
        const hereApiKey = config.hereApiKey;

        const parameters: RouteParameters = {
            departureTime: getDepartureTime(getState()),
            departureDate: format(getDepartureDate(getState()), 'yyyy-MM-dd'),
            waypoints: orderedWaypointsWithCoordinates,
            vehicleAttributes: getVehicleAttributes(getState()),
            considerTraffic: getConsiderTraffic(getState()),
            avoidMotorway: getAvoidMotorway(getState()),
            avoidToll: getAvoidToll(getState()),
            calculateAlternatives: getCalculateAlternatives(getState()),
            currency: getCurrency(getState()),
        };

        const additionalParams: AdditionalParams = {
            departureDateTime: parseISO(`${parameters.departureDate}T${parameters.departureTime}:00`),
            vehicleCostsPerKilometer: getVehicleCostsPerKilometer(getState()),
            currency: parameters.currency,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };

        const queryParams = createRouteQuery(parameters, hereApiKey);

        const hereResponse = await fetchData(`${HERE_ROUTE_ENDPOINT_BASEURL}${queryParams}`);
        datadogLogs.logger.info(
            `Called routes/v8 from here for the following rio account: ${getUserAccount(getState())}`
        );

        dispatch(
            routesActions.suggestedRoutesChanged(
                mapRoutes(hereResponse, orderedWaypointsWithCoordinates, additionalParams)
            )
        );
    } catch (error: any) {
        dispatch(routesActions.fetchRouteSuggestionsFailed(error));
    }
};
